import styled from 'styled-components';
import {CellTitleDefaultBox} from './cell-title.default.box';

export const CellTitleMrGreenBox = styled(CellTitleDefaultBox)`
    color: ${props => props.theme.colors.textContrast};
`;